import React from 'react'

import { Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PersonIcon from '@material-ui/icons/Person'

import Image from 'artkive/components/Image'
import { AccountButton, BrandBannerWrap, BrandLogoButton, BrandsBox } from 'artkive/components/Navbar/BrandsBanner/BrandsBanner.style'
import { NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import routes from 'artkive/utils/routes'

import ArtkiveGrayscaleLogo from 'images/ecom/home/brands-banner/ArtkiveGrayscaleLogo.svg'
import CardkiveGrayscaleLogo from 'images/ecom/home/brands-banner/CardkiveGrayscaleLogo.svg'
import PhotokiveGrayscaleLogo from 'images/ecom/home/brands-banner/PhotokiveGrayscaleLogo.svg'

const useStyles = makeStyles((muiTheme) => ({
  artkiveBrandLogo: {
    width: '80px',
    [muiTheme.breakpoints.up('md')]: {
      width: '96px',
    },
  },
  cardkiveBrandLogo: {
    width: '99px',
    [muiTheme.breakpoints.up('md')]: {
      width: '124px',
    },
  },
  photokiveBrandLogo: {
    width: '104px',
    [muiTheme.breakpoints.up('md')]: {
      width: '132px',
    },
  },
}))

const BrandsBanner = () => {
  const classes = useStyles()

  return (
    <BrandBannerWrap>
      {/* empty block for correct layout*/}
      <div></div>
      <BrandsBox>
        <BrandLogoButton href={routes.home} disableRipple={true}>
          <Image src={ArtkiveGrayscaleLogo} className={classes.artkiveBrandLogo} />
        </BrandLogoButton>
        <BrandLogoButton
          href={routes.cardsByArtkive}
          target={'_blank'}
          trackerEvent={NAVIGATION.CARDS_CLICK}
          disableRipple={true}
        >
          <Image src={CardkiveGrayscaleLogo} className={classes.cardkiveBrandLogo} />
        </BrandLogoButton>
        <BrandLogoButton
          href={routes.photokive}
          target={'_blank'}
          trackerEvent={NAVIGATION.PHOTOKIVE_CLICK}
          disableRipple={true}
        >
          <Image src={PhotokiveGrayscaleLogo} className={classes.photokiveBrandLogo} />
        </BrandLogoButton>
      </BrandsBox>
      <Hidden smDown>
        <AccountButton
          startIcon={<PersonIcon />}
          href={routes.accountOrders}
          trackerEvent={NAVIGATION.MY_ORDERS_CLICK}
        >
          My Account
        </AccountButton>
      </Hidden>
    </BrandBannerWrap>
  )
}

export default BrandsBanner
